export const dateDefaultButtonsList = [
  { value: '+1m', label: '+1m' },
  { value: '+3m', label: '+3m' },
  { value: '+6m', label: '+6m' },
  { value: '+12m', label: '+1y' },
  { value: '+36m', label: '+3y' },
  { value: '+60m', label: '+5y' },
  { value: '+120m', label: '+10y' },
  { value: '+180m', label: '+15y' },
  { value: '-1m', label: '-1m' },
  { value: '-3m', label: '-3m' },
  { value: '-6m', label: '-6m' },
  { value: '-12m', label: '-1y' },
  { value: '-36m', label: '-3y' },
  { value: '-60m', label: '-5y' },
  { value: '-120m', label: '-10y' },
  { value: '-180m', label: '-15y' },
];
